import { Suspense, lazy, Component } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import Layout from './components/layout/Layout'

const Home = lazy(() => import('./pages/Home'))
const About = lazy(() => import('./pages/About'))
const ReviewsPage = lazy(() => import('./pages/Reviews'))
const Blog = lazy(() => import('./pages/Blog'))
const BlogPost = lazy(() => import('./pages/BlogPost'))

function Loading() {
  return (
    <div className="min-h-screen bg-brand-cream flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <div className="w-10 h-10 border-4 border-brand-blue border-t-transparent rounded-full animate-spin" />
        <p className="text-brand-gray font-semibold text-sm">Loading...</p>
      </div>
    </div>
  )
}

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-brand-cream flex items-center justify-center px-4">
          <div className="text-center max-w-md">
            <h1 className="font-heading font-bold text-3xl text-brand-charcoal uppercase mb-4">Something Went Wrong</h1>
            <p className="text-brand-gray mb-6">Sorry about that. Try refreshing the page, or give us a call.</p>
            <a href="tel:+14085788875" className="inline-flex items-center gap-2 bg-brand-blue hover:bg-brand-blue-dark text-white font-heading font-bold px-6 py-3 rounded tracking-wide transition-colors duration-200">
              Call (408) 578-8875
            </a>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}

export default function App() {
  return (
    <HelmetProvider>
      <ErrorBoundary>
        <BrowserRouter>
          <Layout>
            <Suspense fallback={<Loading />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/reviews" element={<ReviewsPage />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route
                  path="*"
                  element={
                    <div className="min-h-screen bg-brand-cream flex items-center justify-center px-4 pt-20">
                      <div className="text-center max-w-md">
                        <h1 className="font-heading font-bold text-5xl text-brand-blue mb-4">404</h1>
                        <h2 className="font-heading font-bold text-2xl text-brand-charcoal uppercase mb-4">Page Not Found</h2>
                        <p className="text-brand-gray mb-6">That page doesn't exist. Let's get you back on track.</p>
                        <a href="/" className="inline-flex items-center gap-2 bg-brand-blue hover:bg-brand-blue-dark text-white font-heading font-bold px-6 py-3 rounded tracking-wide transition-colors duration-200">Go Home</a>
                      </div>
                    </div>
                  }
                />
              </Routes>
            </Suspense>
          </Layout>
        </BrowserRouter>
      </ErrorBoundary>
    </HelmetProvider>
  )
}
